const tickerPositive = {
    svg: '<svg style="width:0.75rem; height:0.75rem;" viewBox="0 0 12 12"><polygon points="1.5 11 6 1 10.5 11"/></svg>',
};

export { tickerPositive as default };
